import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import Input from "@builder/components/general/Input";
import SelectInput from "@builder/components/general/SelectInput";
import Toggle from "@builder/components/general/Toggle";
import useFilterOptions from "@builder/hooks/useFilterEditor";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { setActiveNode, updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { FilterNode } from "@common/build/types";
import { useState } from "react";

const EditDropdownField = ({ parent }: EditableProps) => {
  const dispatch = useAppDispatch();
  const node = useAppSelector(getSelectedNode) as FilterNode;
  const [showLabel, setShowLabel] = useState(!!node.input?.label);


  const active = useAppSelector((state) => state.builder.activeNode) === node.id;
  const activeCallback = (checked: boolean) => {
    dispatch(setActiveNode(checked ? node.id : null));
  };

  const { options: dropdownOptions, value: dropdownValue, callback: dropdownCallback, target } = useFilterOptions({ node });

if (!target) return null;

  const label = node.input?.label || "";
  const labelCallback = (value: string) => {
    dispatch(updateNodeProperty({ propertyPath: ["input", "label"], value }));
  };

  const placeholder = node.input?.placeholder || "";
  const placeholderCallback = (value: string) => {
    dispatch(updateNodeProperty({ propertyPath: ["input", "placeholder"], value }));
  };


  return (
    <SidebarCollapse title="Dropdown Field" parent={parent}>
      <Toggle label="Set Active" checked={active} callback={activeCallback} />
      <SelectInput
        title="Dropdown data"
        layout="column"
        value={dropdownValue}
        options={dropdownOptions}
        callback={dropdownCallback}
      />
      <Toggle
        label="Show label?"
        checked={showLabel}
        callback={() => {
          labelCallback(showLabel ? "" : "Label");
          setShowLabel(!showLabel);
        }}
      />
      {showLabel && <Input label="Label" placeholder="Enter label" value={label} callback={labelCallback} />}
      <Input
        label="Input placeholder"
        placeholder="Enter placeholder"
        value={placeholder}
        callback={placeholderCallback}
      />
    </SidebarCollapse>
  );
};

export default EditDropdownField;
